import { useMetricMasterdataQuery } from "@/common/api/metric/use-metric-masterdata.query";
import { MetricCard } from "@/components/dashboard/cards/metric-card";
import { UserIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function UserMetric() {
  const { t } = useTranslation(["masterdata", "common"]);
  const { data, isLoading } = useMetricMasterdataQuery();

  return <MetricCard icon={UserIcon} label={t("common:Users")} value={data?.userCount ?? 0} loading={isLoading} />;
}
